import {TimeSlotsByDate} from '../types/TimeSlots'

export enum TimeSlotsPageType {
  DEFAULT,
  EXTENDED,
  EMPTY,
}

export const getTimeSlotsPageType = (
  timeSlotsByDays: TimeSlotsByDate,
  selectedDate?: Date,
): TimeSlotsPageType => {
  const daysCount = Object.keys(timeSlotsByDays).length

  if (daysCount === 0) {
    return TimeSlotsPageType.EMPTY
  }

  if (daysCount === 1) {
    const date = Object.keys(timeSlotsByDays)[0]
    return date !== selectedDate?.toDateString()
      ? TimeSlotsPageType.EXTENDED
      : TimeSlotsPageType.DEFAULT
  }

  return TimeSlotsPageType.EXTENDED
}
